var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/ForgeViewerRepo/ModelElementStatus.ts";
import * as t from 'io-ts';
import { Urn } from '../Urn';
export var ModelElementStatus;

(function (_ModelElementStatus) {
  var io = _ModelElementStatus.io = t.type({
    urn: Urn,
    successItems: t.array(t.string),
    failedItems: t.array(t.string)
  }, 'ModelElementCheckupStatus');
})(ModelElementStatus || (ModelElementStatus = {}));